import { DevelopmentalData } from "@/types/developmental";

export const age5Milestones: DevelopmentalData = {
  motor: [
    "Skips and hops with ease",
    "Rides bicycle",
    "Ties shoelaces",
    "Writes letters and numbers",
    "Shows strong hand preference"
  ],
  language: [
    "Uses complex sentences",
    "Understands opposites",
    "Follows 3-part commands",
    "Uses descriptive language",
    "Recognizes many sight words"
  ],
  cognitive: [
    "Counts to 20 or higher",
    "Understands basic addition",
    "Names days of week",
    "Recognizes patterns",
    "Shows early reading skills"
  ],
  independent: [
    "Completes morning routine",
    "Packs school bag",
    "Makes simple food",
    "Follows rules independently",
    "Takes care of personal hygiene"
  ],
  social: [
    "Works cooperatively",
    "Resolves conflicts verbally",
    "Shows empathy",
    "Follows group rules",
    "Maintains friendships"
  ]
};